import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input() name = '';
  @Input() width = '';
  @Input() height = '';
  @Input() margin = '';
  @Input() active = false;
  @Input() hover = false;

  get className(): string {
    return `icon-${this.name}`;
  }
}
